(() => {
  'use strict';

  const root = document.documentElement;
  const header = document.querySelector('[data-site-header]');
  const mobileActionBar = document.querySelector('[data-mobile-action-bar]');

  if (mobileActionBar) {
    root.classList.add('has-mobile-action-bar');

    const corporateFormRegion = document.querySelector('[data-corporate-form-region]');

    if (corporateFormRegion) {
      const setFormSuppressedState = (isSuppressed) => {
        mobileActionBar.classList.toggle('is-suppressed-for-form', isSuppressed);
        mobileActionBar.inert = isSuppressed;

        if (isSuppressed) {
          mobileActionBar.setAttribute('aria-hidden', 'true');
        } else {
          mobileActionBar.removeAttribute('aria-hidden');
        }
      };

      if ('IntersectionObserver' in window) {
        const formObserver = new IntersectionObserver(([entry]) => {
          setFormSuppressedState(entry.isIntersecting);
        });

        formObserver.observe(corporateFormRegion);
      } else {
        let formFrameRequested = false;
        const updateFormSuppressedState = () => {
          const formBounds = corporateFormRegion.getBoundingClientRect();
          setFormSuppressedState(formBounds.bottom > 0 && formBounds.top < window.innerHeight);
          formFrameRequested = false;
        };
        const requestFormUpdate = () => {
          if (formFrameRequested) return;
          formFrameRequested = true;
          window.requestAnimationFrame(updateFormSuppressedState);
        };

        window.addEventListener('scroll', requestFormUpdate, { passive: true });
        window.addEventListener('resize', requestFormUpdate, { passive: true });
        updateFormSuppressedState();
      }
    }
  }

  if (header) {
    const updateHeaderHeight = () => {
      root.style.setProperty('--site-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
    };

    updateHeaderHeight();

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateHeaderHeight).observe(header);
    } else {
      window.addEventListener('resize', updateHeaderHeight, { passive: true });
    }

    let frameRequested = false;
    const updateScrolledState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 48);
      frameRequested = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateScrolledState);
      },
      { passive: true }
    );
    updateScrolledState();
  }

  document.querySelectorAll('[data-mobile-drawer]').forEach((drawer) => {
    const drawerId = drawer.id;
    const opener = document.querySelector(`[aria-controls="${drawerId}"]`);
    const closeButtons = drawer.querySelectorAll('[data-drawer-close]');

    if (!opener || typeof drawer.showModal !== 'function') return;

    const closeDrawer = () => {
      if (drawer.open) drawer.close();
    };

    opener.addEventListener('click', () => {
      drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
      root.classList.add('mobile-drawer-open');
    });

    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) closeDrawer();
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    drawer.addEventListener('close', () => {
      opener.setAttribute('aria-expanded', 'false');
      root.classList.remove('mobile-drawer-open');
      opener.focus({ preventScroll: true });
    });
  });

  const copyPageUrl = async () => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(window.location.href);
      return;
    }

    const copyField = document.createElement('textarea');
    copyField.value = window.location.href;
    copyField.setAttribute('readonly', '');
    copyField.style.position = 'fixed';
    copyField.style.opacity = '0';
    document.body.appendChild(copyField);
    copyField.select();
    document.execCommand('copy');
    copyField.remove();
  };

  document.querySelectorAll('[data-share-page]').forEach((button) => {
    const status = button.closest('[data-mobile-action-bar]')?.querySelector('[data-share-status]');

    button.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href });
          if (status) status.textContent = 'Página compartida.';
        } else {
          await copyPageUrl();
          if (status) status.textContent = 'Enlace copiado al portapapeles.';
        }
      } catch (error) {
        if (error.name !== 'AbortError' && status) {
          status.textContent = 'No fue posible compartir. Copia la dirección desde tu navegador.';
        }
      }
    });
  });
})();
